import { Box } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import { mergeWith } from '@chakra-ui/utils';
import React from 'react';

import { forwardRef } from '../../system';

import DisplayNames from './enums';

import { getChild } from '_helpers/index';
import { IconButtonProps } from 'atoms/Button/IconButton';
import { IconButton, Icon, Menu, MenuButton, MenuList } from 'index';

const hasItems = (children: React.ReactNode): boolean => {
  const iconButtonItem = getChild(DisplayNames.NavBarIconButtonItem, children);
  const tabItem = getChild(DisplayNames.NavBarTabItem, children);
  return !!iconButtonItem || !!tabItem;
};

const defaultProps = {
  variant: 'ghost'
};

export type NavBarIconButtonProps = IconButtonProps;

const NavBarIconButton = forwardRef<NavBarIconButtonProps, 'div'>(
  (props: NavBarIconButtonProps, ref): React.ReactElement => {
    const { children, variant, type, sx, ...rest } = props;
    const navBarTheme = useMultiStyleConfig('NavBarTheme', props);

    const mergedProps = {
      ref,
      size: 'sm' as IconButtonProps['size'],
      ...rest
    };

    return (
      <Box __css={navBarTheme.navBarIconButton}>
        {hasItems(children) ? (
          <Menu>
            <MenuButton
              hideChevron
              sx={mergeWith(navBarTheme.navBarIconMenuButton, sx)}
              variant="ghost"
              {...mergedProps}
            >
              <Icon type={type} />
            </MenuButton>
            <MenuList>{children}</MenuList>
          </Menu>
        ) : (
          <IconButton iconSize="24px" type={type} variant={variant} {...mergedProps} />
        )}
      </Box>
    );
  }
);

NavBarIconButton.displayName = DisplayNames.NavBarIconButton;
NavBarIconButton.defaultProps = defaultProps;

export default NavBarIconButton;
